import type { FirebaseOptions } from "firebase/app";

export const firebaseWebConfig: FirebaseOptions = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export const firebaseVapidKey =
  process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY ?? "";

const requiredConfigValues = [
  firebaseWebConfig.apiKey,
  firebaseWebConfig.authDomain,
  firebaseWebConfig.projectId,
  firebaseWebConfig.messagingSenderId,
  firebaseWebConfig.appId,
  firebaseVapidKey,
];

export const isFirebaseWebMessagingConfigured = requiredConfigValues.every(
  (value) => typeof value === "string" && value.trim().length > 0,
);
